export const HELP_CENTER_LOADING = 'LOADING::HELP_CENTER';
export const SEARCH_LOADING = 'LOADING::SEARCH';
export const CHATS_HISTORY_LOADING = 'LOADING::CHATS_HISTORY';
export const CHAT_HISTORY_LOADING = 'LOADING::CHAT_HISTORY';
export const TICKETS_LOADING = 'LOADING::TICKETS';
export const TICKET_LOADING = 'LOADING::TICKET';
export const CREATE_TICKET_LOADING = 'LOADING::CREATE_TICKET';
export const RESOLVE_TICKET_LOADING = 'LOADING::RESOLVE_TICKET';
export const CATEGORIES_LOADER = 'LOADING::CATEGORIES_LOADER';
